import { CerFormAdapter } from '@cer/cer-form/cer-form-adapter';
import { CerFormView } from '@cer/cer-form/cer-form-view';

export class ProductPoolForm extends CerFormAdapter {

  override view(): CerFormView {
    return  new CerFormView({
      viewMetadata: {
        name: 'udgivelse-print-pulje', dataApiName: 'ProductPool', text: 'Printpuljer',
        primaryKey: 'num', baseFields: ['id', 'num', 'name', 'history']
      }
    });
  }
}
